'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type * as React from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { InputField } from '@/components/ui/input-field';
import { TOAST_IDS } from '@/config/toast-ids';
import { onEvent } from '@/events';
import { showToast } from '@/lib/ui/toast';
import { EarnCard } from './earn-card';
import { useRewardsTips } from './info-tip';
interface Referred {
  handle: string | null;
  status: string;
  pointsContributed: string;
  refersCount: number;
}
interface ReferralsPanelProps {
  referrals: {
    link: string;
    code: string;
    referred: Referred[];
    l1Total: string;
    l2Total: string;
    overrideTodayRemaining: number;
  } | undefined;
}

/** Referral milestone target — the ring fills toward this many referrals (MOR-774). */
const REFERRAL_MAX = 50;
export function ReferralsPanel(t0) {
  const $ = _c(30);
  const {
    referrals
  } = t0;
  const t = useTranslations("rewards");
  const tips = useRewardsTips();
  if (!referrals) {
    return null;
  }
  const {
    link,
    referred
  } = referrals;
  let t1;
  if ($[0] !== link || $[1] !== t) {
    t1 = () => {
      if (typeof navigator === "undefined") {
        return;
      }
      navigator.clipboard?.writeText(link).then(() => {
        onEvent("social_referral_link_copied", {
          method: "copy",
          source: "rewards_dashboard"
        });
        showToast({
          id: TOAST_IDS.REFERRAL_LINK_COPIED,
          message: t("referrals.linkCopied"),
          variant: "success"
        });
      });
    };
    $[0] = link;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const copyLink = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("referrals.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = tips.refer;
  let t4;
  if ($[5] !== t) {
    t4 = t("referrals.pill");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("referrals.description");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = Math.min(referred.length, REFERRAL_MAX) / REFERRAL_MAX * 100;
  const t7 = `${Math.min(referred.length, REFERRAL_MAX)}/${REFERRAL_MAX}`;
  let t8;
  if ($[9] !== t) {
    t8 = t("referrals.title");
    $[9] = t;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== link || $[12] !== t8) {
    t9 = <InputField fullWidth={true} containerClassName="flex-1" value={link} readOnly={true} aria-label={t8} />;
    $[11] = link;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t) {
    t10 = t("referrals.copy");
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== copyLink || $[17] !== t10) {
    t11 = <AnimatedButton variant="secondary" onClick={copyLink}>{t10}</AnimatedButton>;
    $[16] = copyLink;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t9) {
    t12 = <div className="flex items-center gap-2">{t9}{t11}</div>;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t2 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== tips.refer) {
    t13 = <EarnCard data-testid="referrals-panel" title={t2} tip={t3} points={t4} description={t5} progress={t6} progressLabel={t7}>{t12}</EarnCard>;
    $[22] = t12;
    $[23] = t2;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = tips.refer;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}